import { Button } from "@/components/ui/button"
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { uploadCsvReport } from "@/redux/actions/testKitActions"
import { useState } from "react"
import { useDispatch } from "react-redux"
import { useParams } from "react-router-dom"

const UploadCsv = () => {

    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [formState, setFormState] = useState({
        taxa_file: null,
        metrics_file: null,
    })
    const [error, setError] = useState<string>("")

    const params = useParams()
    const dispatch: any = useDispatch()

    const handleFileChange = (key: string, value: File | null) => {
        setFormState((prevState) => ({
            ...prevState,
            [key]: value,
        }))
    }

    const validateInput = () => {
        let errorMessage = ""
        if (!formState.taxa_file || formState.taxa_file === "") {
            errorMessage = 'Taxa file is required'
        } else if (!formState.metrics_file || formState.metrics_file === "") {
            errorMessage = 'Metrics file is required'
        } else {
            errorMessage = ''
        }
        setError(errorMessage)
        return errorMessage
    }

    const handleSubmit = () => {
        const errorMessage = validateInput()
        if (!errorMessage) {
            const payload = {
                "taxa_file": formState.taxa_file,
                "metrics_file": formState.metrics_file,
            }
            dispatch(uploadCsvReport(Number(params.id), payload, () => setIsOpen(false)))
        }
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="secondary">Upload Test Analysis</Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Upload Test Analysis</DialogTitle>
                    <DialogDescription>
                        Upload the Test Analysis files of the test kit.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    {error && <div className="grid grid-cols-4 items-center gap-4">
                        <div className="col-span-1"></div>
                        <div className="col-span-3">
                            <p className="text-red-500 text-sm">{error}</p>
                        </div>
                    </div>}
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="taxa_file" className="text-right">
                            Taxa File
                        </Label>
                        <Input
                            id="taxa_file"
                            name="taxa_file"
                            className="col-span-3"
                            type="file"
                            accept=".csv"
                            onChange={(e) => handleFileChange("taxa_file", e.target.files && e.target.files[0])}
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="metrics_file" className="text-right">
                            Metrics File
                        </Label>
                        <Input
                            id="metrics_file"
                            name="metrics_file"
                            className="col-span-3"
                            type="file"
                            accept=".csv"
                            onChange={(e) => handleFileChange("metrics_file", e.target.files && e.target.files[0])}
                        />
                    </div>
                </div>
                <DialogFooter>
                    <Button type="submit" onClick={() => handleSubmit()}>Upload</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default UploadCsv
